import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import Sidebar from "./Sidebar";
import Header from "./Header";

const { Content } = Layout;

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 260,
          transition: "margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
          height: "100vh",
          overflow: "auto",
        }}
      >
        <Header />
        <Content
          style={{
            padding: "20px 28px",
            minHeight: "calc(100vh - 56px)",
            background: "linear-gradient(135deg, #F9FAFB 0%, #F3F4F6 100%)",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
